module.exports = __webpack_public_path__ + "static/primary-stacked-blue-9329b712991b3dba854cbf50153d62e6.png";